/**
 * Maps an IRI from notification context (e.g. materialId, bookingId, authorId) to a frontend route.
 * IRIs are of the form /materials/xxx, /material_bookings/yyy, /users/zzz.
 * The last path segment is used as the route parameter (slug or id).
 */
export function contextIriToRoute(iri: string): { to: string } | null {
  if (!iri || typeof iri !== 'string') return null
  const trimmed = iri.trim()
  if (!trimmed) return null
  const segments = trimmed.split('/').filter(Boolean)
  const last = segments[segments.length - 1]
  if (!last) return null
  if (trimmed.includes('/materials/')) return { to: `/materials/${last}` }
  if (trimmed.includes('/material_bookings/'))
    return { to: `/my/bookings/${last}` }
  if (trimmed.includes('/users/')) return { to: `/user/${last}` }
  return null
}
